import { render, staticRenderFns } from "./CompareView.vue?vue&type=template&id=5d9dfce2"
import script from "./CompareView.vue?vue&type=script&lang=js"
export * from "./CompareView.vue?vue&type=script&lang=js"
import style0 from "./CompareView.vue?vue&type=style&index=0&id=5d9dfce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports